var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "m-0", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mostrarFiltroOpciones,
                      expression: "mostrarFiltroOpciones",
                    },
                  ],
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-2" },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "seleccionTablas.label.filtrtarEnDisponibles"
                          ),
                          disabled: _vm.disabled,
                        },
                        on: { keyup: _vm.filtrarOpciones },
                        model: {
                          value: _vm.filtroOpciones,
                          callback: function ($$v) {
                            _vm.filtroOpciones = $$v
                          },
                          expression: "filtroOpciones",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mt-0 ml-3" },
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-v": "end" } },
                        [
                          _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                            _c(
                              "p",
                              { staticClass: "h6" },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "seleccionTablas.label.disponibles"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-badge",
                                  { attrs: { pill: "", variant: "primary" } },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.opcionesBase.length
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                            _c(
                              "p",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          _vm.mostrarDisponiblesExtendidas
                                            ? "seleccionTablas.label.mostrarListaChica"
                                            : "seleccionTablas.label.mostrarListaGrande"
                                        ),
                                        expression:
                                          "\n                    $t(\n                      mostrarDisponiblesExtendidas\n                        ? 'seleccionTablas.label.mostrarListaChica'\n                        : 'seleccionTablas.label.mostrarListaGrande'\n                    )\n                  ",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "link",
                                      size: "sm",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.mostrarDisponiblesExtendidas =
                                          !_vm.mostrarDisponiblesExtendidas
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: _vm.mostrarDisponiblesExtendidas
                                          ? "arrows-collapse"
                                          : "arrows-expand",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          "seleccionTablas.label.mostrarOcultarFiltros"
                                        ),
                                        expression:
                                          "$t('seleccionTablas.label.mostrarOcultarFiltros')",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "link",
                                      size: "sm",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.mostrarFiltroOpciones =
                                          !_vm.mostrarFiltroOpciones
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "filter-circle" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          "seleccionTablas.label.pasarTodosASeleccionados"
                                        ),
                                        expression:
                                          "$t('seleccionTablas.label.pasarTodosASeleccionados')",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "link",
                                      size: "sm",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.pasarTodoASelecciones()
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "chevron-double-right" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass: "area-responsive table-responsive",
                          class: {
                            "table-responsive-fail": _vm.state == false,
                            "table-responsive-success": _vm.state == true,
                            "componente-disabled": _vm.disabled,
                            "table-responsive-alta":
                              _vm.mostrarDisponiblesExtendidas,
                          },
                        },
                        [
                          _c(
                            "b-list-group",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  value: _vm.$t(
                                    "seleccionTablas.label.pasarASeleccionados"
                                  ),
                                  expression:
                                    "$t('seleccionTablas.label.pasarASeleccionados')",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                            },
                            _vm._l(_vm.opcionesFiltrado, function (item) {
                              return _c(
                                "b-list-group-item",
                                {
                                  key: item.text,
                                  staticClass:
                                    "d-flex justify-content-between align-items-center",
                                  class: {
                                    "componente-disabled": _vm.disabled,
                                  },
                                  attrs: { button: "", disabled: _vm.disabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.pasarASelecciones(item)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(item.text),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("b-icon", {
                                    attrs: { icon: "chevron-compact-right" },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mostrarFiltroSelecciones,
                      expression: "mostrarFiltroSelecciones",
                    },
                  ],
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-2" },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "seleccionTablas.label.filtrtarEnSeleccionados"
                          ),
                          disabled: _vm.disabled,
                        },
                        on: { keyup: _vm.filtrarSelecciones },
                        model: {
                          value: _vm.filtroSelecciones,
                          callback: function ($$v) {
                            _vm.filtroSelecciones = $$v
                          },
                          expression: "filtroSelecciones",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mt-0 ml-3" },
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-v": "end" } },
                        [
                          _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                            _c(
                              "p",
                              { staticClass: "h6" },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "seleccionTablas.label.seleccionados"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-badge",
                                  { attrs: { pill: "", variant: "primary" } },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.seleccionadoBase.length
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                            _c(
                              "p",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          _vm.mostrarSeleccionadasExtendidas
                                            ? "seleccionTablas.label.mostrarListaChica"
                                            : "seleccionTablas.label.mostrarListaGrande"
                                        ),
                                        expression:
                                          "\n                    $t(\n                      mostrarSeleccionadasExtendidas\n                        ? 'seleccionTablas.label.mostrarListaChica'\n                        : 'seleccionTablas.label.mostrarListaGrande'\n                    )\n                  ",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "link",
                                      size: "sm",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.mostrarSeleccionadasExtendidas =
                                          !_vm.mostrarSeleccionadasExtendidas
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: _vm.mostrarSeleccionadasExtendidas
                                          ? "arrows-collapse"
                                          : "arrows-expand",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          "seleccionTablas.label.mostrarOcultarFiltros"
                                        ),
                                        expression:
                                          "$t('seleccionTablas.label.mostrarOcultarFiltros')",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "link",
                                      size: "sm",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.mostrarFiltroSelecciones =
                                          !_vm.mostrarFiltroSelecciones
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "filter-circle" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          "seleccionTablas.label.pasarTodosADisponibles"
                                        ),
                                        expression:
                                          "$t('seleccionTablas.label.pasarTodosADisponibles')",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "link",
                                      size: "sm",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.pasarTodoAOpciones()
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "chevron-double-left" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass: "area-responsive table-responsive",
                          class: {
                            "table-responsive-fail": _vm.state == false,
                            "table-responsive-success": _vm.state == true,
                            "componente-disabled": _vm.disabled,
                            "table-responsive-alta":
                              _vm.mostrarSeleccionadasExtendidas,
                          },
                        },
                        [
                          _c(
                            "b-list-group",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  value: _vm.$t(
                                    "seleccionTablas.label.pasarADisponibles"
                                  ),
                                  expression:
                                    "$t('seleccionTablas.label.pasarADisponibles')",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                            },
                            _vm._l(_vm.seleccionFiltrado, function (item) {
                              return _c(
                                "b-list-group-item",
                                {
                                  key: item.text,
                                  staticClass:
                                    "d-flex justify-content-between align-items-center",
                                  class: {
                                    "componente-disabled": _vm.disabled,
                                  },
                                  attrs: { button: "", disabled: _vm.disabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.pasarAOpciones(item)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(item.text),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("b-icon", {
                                    attrs: { icon: "chevron-compact-left" },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }